import { Observable } from "rxjs";
import { ContentGetQueryResult, EContentLocation } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IContentService {
  abstract contentGet(parent?: string, location?: EContentLocation): Observable<ContentGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IContentServiceToken = new InjectionToken<IContentService>('IContentServiceToken');
